import React, { FC, useState } from 'react';
import { useDispatch } from 'react-redux';

import Modal from '../../../ui/Modal';
import { Button } from '../../../ui';
import { hideModal } from '../../../store/Modal/Modal.action';
import { showToast } from '../../../store/Toast/Toast.action';
import { gatewaysApi } from '../../../services/gateways';

type PropsType = {
  className?: string;
  isVisible: boolean;
  gatewayId?: number;
  gatewayName?: string;
  devicesCount?: number;
  onDeleted?: () => void;
};

const WidgetModalGatewayDelete: FC<PropsType> = ({
  className,
  isVisible,
  gatewayId,
  gatewayName,
  devicesCount,
  onDeleted,
}) => {
  const dispatch = useDispatch();
  const [isDeleting, setIsDeleting] = useState(false);

  const handleClose = () => {
    dispatch(hideModal());
  };

  // FR-90 п.4: кнопка [Delete] всегда активна; повторные клики во время
  // запроса игнорируются, чтобы не удалить дважды.
  const handleDelete = async () => {
    if (isDeleting || !gatewayId) return;
    setIsDeleting(true);
    try {
      await gatewaysApi.remove(gatewayId);
      // FR-90 4c/4d/4e: закрыть окно, обновить таблицу и статистику, показать тост.
      dispatch(hideModal());
      onDeleted?.();
      dispatch(showToast('The gateway was successfully deleted.', 'success'));
    } catch {
      // FR-90: при ошибке удаление не выполняется, окно остаётся открытым.
      dispatch(showToast('Failed to delete gateway. Please try again later.', 'error'));
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <Modal
      className={`modal-delete-user modal-delete-gateway ${className || ''}`}
      isVisible={isVisible}
      isClose
      isCloseBg
      title="Delete gateway?"
    >
      <div className="modal-delete-user__content">
        <p>
          Are you sure you want to delete{' '}
          {gatewayName ? <strong>&apos;{gatewayName}&apos;</strong> : 'this'} gateway?
        </p>
        <p>
          Gateway configuration guide, network registration, and connection history
          will be permanently deleted. Sensor data and alert history will not be
          affected. This action cannot be undone.
        </p>

        <div className="modal-delete-gateway__warning">
          Warning: {devicesCount ?? 0} sensors will be disconnected from the network
          and stop reporting.
        </div>
      </div>
      <div className="modal-delete-user__action">
        <Button size="large" type="button" variant="secondary" onClick={handleClose}>
          Cancel
        </Button>

        <Button
          size="large"
          type="button"
          className="modal-delete-gateway__confirm"
          onClick={handleDelete}
        >
          Delete
        </Button>
      </div>
    </Modal>
  );
};

export default WidgetModalGatewayDelete;
